import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { WUniqueFormat } from '../../base/unique-format';
import { WUniqueFormats } from '../../base/unique-formats';
import { Dictionary } from '../../base/dictionary';
/* eslint-disable */
/**
 * @private
 */
export class WShading {
    constructor(node) {
        this.uniqueShadingFormat = undefined;
        this.ownerBase = undefined;
        this.ownerBase = node;
    }
    get backgroundColor() {
        return this.getPropertyValue('backgroundColor');
    }
    set backgroundColor(value) {
        this.setPropertyValue('backgroundColor', value);
    }
    get foregroundColor() {
        return this.getPropertyValue('foregroundColor');
    }
    set foregroundColor(value) {
        this.setPropertyValue('foregroundColor', value);
    }
    get textureStyle() {
        return this.getPropertyValue('textureStyle');
    }
    set textureStyle(value) {
        this.setPropertyValue('textureStyle', value);
    }
    getPropertyValue(property) {
        const hasValue = this.hasValue(property);
        if (hasValue) {
            const propertyType = WUniqueFormat.getPropertyType(WShading.uniqueFormatType, property);
            if (!isNullOrUndefined(this.uniqueShadingFormat) && this.uniqueShadingFormat.propertiesHash.containsKey(propertyType)) {
                return this.uniqueShadingFormat.propertiesHash.get(propertyType);
            }
        }
        return WShading.getPropertyDefaultValue(property);
    }
    setPropertyValue(property, value) {
        if (isNullOrUndefined(value) || value === '') {
            value = WShading.getPropertyDefaultValue(property);
        }
        if (isNullOrUndefined(this.uniqueShadingFormat)) {
            this.initializeUniqueShading(property, value);
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueShadingFormat.uniqueFormatType, property);
            if (this.uniqueShadingFormat.propertiesHash.containsKey(propertyType) &&
                this.uniqueShadingFormat.propertiesHash.get(propertyType) === value) {
                //Do nothing, since no change in property value and return
                return;
            }
            this.uniqueShadingFormat = WShading.uniqueShadingFormats.updateUniqueFormat(this.uniqueShadingFormat, property, value);
        }
    }
    static getPropertyDefaultValue(property) {
        let value = undefined;
        switch (property) {
            case 'backgroundColor':
                value = 'empty';
                break;
            case 'foregroundColor':
                value = 'empty';
                break;
            case 'textureStyle':
                value = 'TextureNone';
                break;
        }
        return value;
    }
    initializeUniqueShading(property, propValue) {
        const uniqueShadingTemp = new Dictionary();
        this.addUniqueShading('backgroundColor', property, propValue, uniqueShadingTemp);
        this.addUniqueShading('foregroundColor', property, propValue, uniqueShadingTemp);
        this.addUniqueShading('textureStyle', property, propValue, uniqueShadingTemp);
        this.uniqueShadingFormat = WShading.uniqueShadingFormats.addUniqueFormat(uniqueShadingTemp, WShading.uniqueFormatType);
    }
    addUniqueShading(property, modifiedProperty, propValue, uniqueShadingTemp) {
        const propertyType = WUniqueFormat.getPropertyType(WShading.uniqueFormatType, property);
        if (property === modifiedProperty) {
            uniqueShadingTemp.add(propertyType, propValue);
        }
        else {
            uniqueShadingTemp.add(propertyType, WShading.getPropertyDefaultValue(property));
        }
    }
    destroy() {
        if (!isNullOrUndefined(this.uniqueShadingFormat)) {
            WShading.uniqueShadingFormats.remove(this.uniqueShadingFormat);
        }
        this.uniqueShadingFormat = undefined;
    }
    cloneFormat() {
        const shading = new WShading(undefined);
        shading.backgroundColor = this.backgroundColor;
        shading.foregroundColor = this.foregroundColor;
        shading.textureStyle = this.textureStyle;
        return shading;
    }
    copyFormat(shading) {
        if (!isNullOrUndefined(shading) && !isNullOrUndefined(shading.uniqueShadingFormat)) {
            this.backgroundColor = shading.backgroundColor;
            this.foregroundColor = shading.foregroundColor;
            this.textureStyle = shading.textureStyle;
        }
    }
    hasValue(property) {
        if (!isNullOrUndefined(this.uniqueShadingFormat)) {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueShadingFormat.uniqueFormatType, property);
            return this.uniqueShadingFormat.propertiesHash.containsKey(propertyType);
        }
        return false;
    }
    static clear() {
        this.uniqueShadingFormats.clear();
    }
}
WShading.uniqueShadingFormats = new WUniqueFormats();
WShading.uniqueFormatType = 5;
